// pieces and components

const initCursor = () => {
	const cursorArea = document.querySelectorAll('.cursor-area');
	cursorArea.forEach((section) => {
		let button = section.querySelector('[data-cursor]');
		let buttonCloned = button.cloneNode(true);

		section.appendChild(buttonCloned);
		buttonCloned.classList.add('is-cloned');

		section.addEventListener('mouseenter', (e) => {
			section.classList.add('is-mouse-enter');
			buttonCloned.style.top = `${
				e.clientY - section.getBoundingClientRect().top
			}px`;
			buttonCloned.style.left = `${
				e.clientX - section.getBoundingClientRect().left
			}px`;
		});

		section.addEventListener('mousemove', (e) => {
			if (e.target != section) {
				section.classList.remove('is-mouse-enter');
			} else {
				buttonCloned.style.top = `${
					e.clientY - section.getBoundingClientRect().top
				}px`;
				buttonCloned.style.left = `${
					e.clientX - section.getBoundingClientRect().left
				}px`;
			}
		});

		section.addEventListener('mouseleave', (e) => {
			section.classList.remove('is-mouse-enter');
		});
	});
};

const initMessage = () => {
	const messages = Array.prototype.slice.call(
		document.querySelectorAll('.global-message .message')
	);
	let max = 0;
	const setHeight = () => {
		messages.forEach((item) => {
			if (item.scrollHeight > max) {
				max = item.scrollHeight;
			}
			item.style.minHeight = `${max}px`;
		});
	};

	const interval = (element, isMessage, time) => {
		const messages_count = element.length;

		let active_message_index = 0;
		if (messages_count > 0) {
			setInterval(function () {
				let activeElement = isMessage
					? document.querySelector('.global-message .message.active')
					: document.querySelector('.global-message .span.active');
				if (element.indexOf(activeElement) == messages_count - 1)
					active_message_index = 0;
				else active_message_index++;
				activeElement.classList.remove('active');
				element[active_message_index].classList.add('active');
			}, time);
		}
	};

	setHeight();
	window.addEventListener('resize', setHeight);
	interval(messages, true, 5000);
};

const initMarquee = () => {
	const _marquee = document.querySelectorAll('.marquee');

	_marquee.forEach((carousel, i) => {
		let requestId;
		let playSpeed = carousel.hasAttribute('data-marquee-speed')
			? carousel.getAttribute('data-marquee-speed')
			: 1;

		let factor = Math.ceil(window.innerWidth / carousel.clientWidth);
		let carouselHtml = carousel.innerHTML;

		for (i = 0; i < factor; i++) {
			carousel.innerHTML += carouselHtml;
		}

		setTimeout(function () {
			const mainTicker = new Flickity(carousel, {
				accessibility: true,
				resize: true,
				wrapAround: true,
				prevNextButtons: false,
				pageDots: false,
				percentPosition: true,
				setGallerySize: true,
				draggable: true,
			});

			const play = () => {
				mainTicker.x = mainTicker.x - playSpeed;
				mainTicker.settle(mainTicker.x);
				requestId = window.requestAnimationFrame(play);
			};

			carousel.classList.add('is-active');

			mainTicker.x = 0;

			setTimeout(function () {
				mainTicker.resize();
				play();
			});
		});
	});
};

const initAccordion = () => {
	const accordion = document.querySelectorAll('.comp-accordion');

	accordion.forEach((el) => {
		el.querySelector('.accordion-label').addEventListener('click', (e) => {
			let content = el.querySelector('.accordion-content');

			// activate current accordion
			slide('toggle', content);

			if (!el.classList.contains('is-active')) {
				el.classList.add('is-active');
				el.setAttribute('aria-expanded', true);
				content.setAttribute('aria-hidden', false);
			} else {
				el.classList.remove('is-active');
				el.setAttribute('aria-expanded', false);
				content.setAttribute('aria-hidden', true);
			}

			accordion.forEach((el2) => {
				if (el2 != el) {
					// inactive all other accordions
					slide('up', el2.querySelector('.accordion-content'));
					el2.classList.remove('is-active');
					el2
						.querySelector('.accordion-label')
						.setAttribute('aria-expanded', false);
					el2.setAttribute('aria-hidden', true);
				}
			});
		});
	});
};

const initItemQuantity = () => {
	document.addEventListener('click', (e) => {
		if (
			e.target &&
			(e.target.dataset.quantityTrigger ||
				e.target.closest('[data-quantity-trigger]'))
		) {
			let target = e.target.dataset.quantityTrigger
				? e.target
				: e.target.closest('[data-quantity-trigger]');
			let itemQuantity = target.closest('.item-quantity');
			let quantityInput = itemQuantity.querySelector('input[name="quantity"]');
			let inputDecrease = itemQuantity.querySelector(
				'[data-quantity-trigger="decrease"]'
			);
			let inputIncrease = itemQuantity.querySelector(
				'[data-quantity-trigger="increase"]'
			);
			let updatedValue =
				parseInt(quantityInput.value) +
				(target.dataset.quantityTrigger == 'increase'
					? parseInt(quantityInput.value) + 1 <= parseInt(quantityInput.max)
						? 1
						: 0
					: parseInt(quantityInput.value) - 1 >= parseInt(quantityInput.min)
					? -1
					: 0);

			updatedValue <= quantityInput.min
				? inputDecrease.classList.add('is-inactive')
				: inputDecrease.classList.remove('is-inactive');

			updatedValue >= quantityInput.max
				? inputIncrease.classList.add('is-inactive')
				: inputIncrease.classList.remove('is-inactive');

			quantityInput.value = target.classList.contains('has-leading-zero')
				? formatLeadingZero(updatedValue)
				: updatedValue;
		}
	});
};

const initFields = () => {
	const fields = document.querySelectorAll('.field');

	fields.forEach((item) => {
		let input = item.querySelector(`input[type="text"],
			input[type="email"], 
			input[type="tel"],
			input[type="url"],
			input[type="password"],
			input[type="file"],
			textarea`);
		let determineHasValue = () => {
			input.value
				? item.classList.add('has-value')
				: item.classList.remove('has-value');
		};

		if (input) {
			determineHasValue();
			input.addEventListener('change', determineHasValue);
			input.addEventListener('blur', determineHasValue);
		}
	});
};

const initFlickitySlider = () => {
	const flickitySlider = document.querySelectorAll('[data-flickity-slider]');

	const flickitySliderTrigger = () => {
		flickitySlider.forEach((el) => {
			let flickity = new Flickity(
				el,
				JSON.parse(el.dataset.flickitySlider.replace(/'/g, '"').trim())
			);
			let childrenWidth = Object.values(
				el.querySelector('.flickity-slider').childNodes
			).reduce(
				(total, i) =>
					i.offsetWidth
						? total +
						  i.offsetWidth +
						  parseInt(window.getComputedStyle(i).marginLeft) +
						  parseInt(window.getComputedStyle(i).marginRight)
						: total,
				0
			);

			if (
				// if total children width is lesser than slider width
				el.getBoundingClientRect().width >= childrenWidth ||
				// if flickity slider has breakpoint set, and window is greater than breakpoint
				(el.dataset.flickityBreakpoint &&
					window.innerWidth > parseInt(el.dataset.flickityBreakpoint))
			) {
				// destroy flickity
				flickity.destroy();

				setTimeout(() => {
					el.querySelectorAll('[style*="left:"]').forEach((item) => {
						item.style.setProperty('left', 'unset');
					});
				}, 100);
			} else {
				// avoid click on drag: https://github.com/metafizzy/flickity/issues/838
				flickity.on('dragStart', () =>
					flickity.slider.childNodes.forEach(
						(slide) => (slide.style.pointerEvents = 'none')
					)
				);

				flickity.on('dragEnd', () =>
					flickity.slider.childNodes.forEach(
						(slide) => (slide.style.pointerEvents = 'all')
					)
				);
			}
		});
	};

	flickitySliderTrigger();
	window.addEventListener('resize', flickitySliderTrigger);

	// swipe fix for IOS
	var touchingCarousel = false;
	var touchStartCoords;

	document.body.addEventListener('touchstart', function (e) {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}

		touchStartCoords = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY,
		};
	});

	document.body.addEventListener(
		'touchmove',
		function (e) {
			if (!(touchingCarousel && e.cancelable)) {
				return;
			}

			var moveVector = {
				x: e.touches[0].pageX - touchStartCoords.x,
				y: e.touches[0].pageY - touchStartCoords.y,
			};

			if (Math.abs(moveVector.x) > 7) {
				e.preventDefault();
			}
		},
		{
			passive: false,
		}
	);
};

// global elements and pages

const initHeader = () => {
	const headerScroll = () => {
		window.scrollY > 50
			? root.classList.add('header-is-sticky')
			: root.classList.remove('header-is-sticky');
		// if scroll direction is upwards
		this.oldScroll > window.scrollY
			? root.classList.add('scroll-up')
			: root.classList.remove('scroll-up');

		this.oldScroll = window.scrollY;
	};

	headerScroll();
	window.addEventListener('scroll', headerScroll);

	window.addEventListener('resize', () => {
		root.classList.remove('header-is-scrolled');
		root.classList.remove('header-is-sticky');
	});
};

const initPageTransition = () => {
	document.querySelectorAll('a[href]').forEach((item) => {
		// if href points to anchor, or points to anchor that exists on page
		if (
			item.href.startsWith('#') ||
			(item.href.split('#')[1] &&
				item.href.split('#')[0] == window.location.href.split('#')[0])
		) {
			item.setAttribute('data-page-transition', 'scroll');
		} else if (
			(item.href.includes(siteUrl) || item.href.startsWith('/')) &&
			item.target != '_blank' &&
			!item.href.includes('mailto:')
		) {
			item.setAttribute('data-page-transition', 'internal');
		} else {
			item.rel = 'noopener';
			item.target = item.target || '_blank';
		}
	});

	document.querySelectorAll('[data-page-transition]').forEach((item) => {
		item.addEventListener('click', (e) => {
			let target = e.target.hasAttribute('data-page-transition')
				? e.target
				: e.target.closest('[data-page-transition]');

			target.blur();

			if (
				target.dataset.pageTransition == 'internal' &&
				!root.classList.contains('key-is-down')
			) {
				e.preventDefault();
				root.classList.remove(
					'header-is-sticky',
					'menu-is-active',
					'mobile-menu-is-active',
					'minicart-is-active'
				);
				root.classList.add('is_leaving');
				root.classList.remove('is_loaded');

				setTimeout(() => {
					location.href = target.href;
				}, 400);
			} else if (target.dataset.pageTransition == 'scroll') {
				e.preventDefault();
				// let topOfElement =
				// 	document.querySelector(`#${target.href.split('#')[1]}`).offsetTop -
				// 	220;

				seamless.elementScrollIntoView(
					document.querySelector(`#${target.href.split('#')[1]}`),
					{
						behavior: 'smooth',
					}
				);
			}
		});
	});

	window.addEventListener('keydown', () => {
		root.classList.add('key-is-down');
	});

	window.addEventListener('keyup', () => {
		root.classList.remove('key-is-down');
	});
};

const initPageAnimation = () => {
	document.querySelectorAll('[data-animate]').forEach((item) => {
		let observer = new IntersectionObserver(
			(el) => {
				if (
					el[0].isIntersecting === true &&
					!el[0].target.classList.contains('is-animated')
				) {
					el[0].target.classList.add('is-animated');
				}
			},
			{ threshold: [0.1] }
		); // 0 = page start; 1 = page bottom, items only revealed when in full view

		observer.observe(item);
	});
};

const initCart = () => {
	// cart visibility
	const minicartClose = () => {
		root.classList.remove('minicart-is-active');
		root.classList.remove('noscroll');
		history.pushState(null, null, ' ');
	};

	const minicartOpen = () => {
		if (root.classList.contains('mobile-menu-is-active')) {
			root.classList.remove('mobile-menu-is-active');
			root.classList.add('noscroll');
		}
		root.classList.add('minicart-is-active');
		history.pushState(null, null, '#cart');
	};

	document.addEventListener('click', (e) => {
		// open cart trigger
		if (
			e.target &&
			(e.target.classList.contains('minicart-open') ||
				e.target.closest('.minicart-open'))
		) {
			root.classList.contains('minicart-is-active')
				? minicartClose()
				: minicartOpen();
		}

		// close cart trigger
		if (
			e.target &&
			(e.target.classList.contains('minicart-close') ||
				e.target.closest('.minicart-close'))
		) {
			minicartClose();
		}
	});

	// trigger cart if url contains the hash
	if (location.hash == '#cart') {
		minicartOpen();
	}

	// updates both cart price and item count
	this.reloadCartData = () => {
		fetch('/cart.js')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				document.querySelectorAll('.cart-total-price').forEach((item) => {
					item.innerText = `$${parseFloat(data.total_price / 100).toFixed(2)}`;
				});

				document.querySelectorAll('.cart-total-items').forEach((item) => {
					item.innerText = data.item_count;
				});

				data.item_count > 0
					? root.classList.add('cart-has-items')
					: root.classList.remove('cart-has-items');

				//check if cart contains subscription item
				const cartItems = document.querySelectorAll('.cart-item');
				const discount = document.querySelector('.cart-discount').value;

				for (let item of cartItems) {
					if (item.classList.contains('cart-subscription')) {
						document
							.querySelector('.checkout-btn')
							.setAttribute(
								'href',
								`${location.origin}/checkout/?discount=${discount}`
							);
						break;
					} else {
						document
							.querySelector('.checkout-btn')
							.setAttribute('href', `${location.origin}/checkout/`);
					}
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	reloadCartData();

	// updates s HTML
	this.reloadCartItems = () => {
		fetch('/cart')
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				var parser = new DOMParser();
				var dataHtml = parser.parseFromString(data, 'text/html');

				// insert the new cart items
				document.querySelectorAll('.cart-items-wrapper').forEach((item) => {
					item.innerHTML = dataHtml.querySelector(
						'.cart-items-wrapper'
					).innerHTML;
				});

				reloadCartData();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// use this function to add items
	this.addItem = (
		variantId,
		quantity,
		sellingPlan,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 400,
		callback
	) => {
		let parameters = {
			id: variantId,
			quantity: quantity,
			...sellingPlan,
		};

		fetch('/cart/add.js', {
			method: 'POST',
			body: JSON.stringify(parameters),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then((response) => {
				response.json();
			})
			.then((data) => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';

				if (callback) {
					callback();
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// use this function to change item quantity
	this.changeItemQuantity = (
		line,
		quantity,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 400
	) => {
		fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				line: line,
				quantity: quantity,
			}),
		})
			.then((response) => {
				response.json();
			})
			.then(() => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	on(
		'body',
		'click',
		'[data-quantity-trigger], [data-quantity-trigger] *',
		(e) => {
			let target = e.target.closest('[data-quantity-trigger]');
			let item = e.target.closest('.cart-item');

			if (item) {
				setTimeout(() => {
					item.querySelectorAll('[name="quantity"]').forEach((item) => {
						item.value = target
							.closest('.item-quantity')
							.querySelector('[name="quantity"]').value;
					});

					changeItemQuantity(
						item.dataset.itemLine,
						item.querySelector('[name="quantity"]').value,
						true,
						false,
						false
					);
				}, 10);
			}
		}
	);

	on('body', 'click', '.item-remove-trigger, .item-remove-trigger *', (e) => {
		let item = e.target.closest('.cart-item');

		if (item) {
			item.remove();
			changeItemQuantity(item.dataset.itemLine, 0, true, false, false);
		}
	});

	on('body', 'click', '[data-set-cart-add], [data-set-cart-add] *', (e) => {
		let target = e.target.closest('[data-set-cart-add]');

		addItem(
			target.dataset.cartAdd,
			target.dataset.cartAddQuantity ? target.dataset.cartAddQuantity : 1
		);
	});

	on('body', 'submit', 'form[action="/cart/add"]', (e) => {
		e.preventDefault();
		let form = e.target.closest('form[action="/cart/add"]');

		const isSubscription = form.dataset.activeType && form.dataset.activeType.includes('subscription');
		const propertiesSubscription = form.querySelector(
			'input[name="properties[subscription]"]'
		);

		const subscriptionPlan = propertiesSubscription.dataset.plan;
		const subscriptionId = propertiesSubscription.value;

		let sellingPlan = {
			...(isSubscription && { selling_plan: subscriptionId }),
			properties: {
				...(isSubscription && { Subscription: subscriptionPlan }),
			},
		};

		addItem(
			form.querySelector('[name="id"]').value,
			form.querySelector('[name="quantity"]').value,
			sellingPlan
		);
	});
};

const initAccount = () => {
	// account gate
	const gateWrapper = document.querySelector('.account-gate-wrapper');
	const gateContent = document.querySelector('.account-gate');
	const resetPasswordTrigger = document.querySelector(
		'.reset-password-trigger'
	);
	const resetPasswordCancel = document.querySelector('.reset-password-cancel');

	if (gateWrapper) {
		resetPasswordTrigger.addEventListener('click', (event) => {
			event.preventDefault();

			// update URL with hash
			history.pushState(null, null, '#recover');

			// assign active state
			root.classList.add('reset-password-active');

			// update wrapper height to fit account reset form
			gateWrapper.style.height =
				document.querySelector('.account-reset').offsetHeight;

			// focus on email field
			document.querySelector('#account-recover-email').focus();
		});

		if (resetPasswordCancel) {
			resetPasswordCancel.addEventListener('click', (event) => {
				event.preventDefault();

				// remove has from URL
				history.pushState(null, null, ' ');

				// remove active state from root
				root.classList.remove('reset-password-active');

				// update wrapper height to fit account reset form
				gateWrapper.style.height = gateContent.offsetHeight;
			});
		}

		// trigger password recovery form if url contains the hash
		if (location.hash == '#recover') {
			resetPasswordTrigger.click();
		}

		// set initial height
		gateWrapper.style.height = gateContent.offsetHeight;
	}
};

const initFrontpage = () => {
	const blockLeft = document.querySelector(
		'.product-duo-blocks .block-link-left'
	);
	const blockRight = document.querySelector(
		'.product-duo-blocks .block-link-right'
	);

	const hoverEffect = () => {
		if (window.innerWidth > 900) {
			blockLeft.addEventListener('mouseover', () => {
				blockLeft
					.closest('.frontpage-product-duo')
					.classList.add('left-active');
			});

			blockLeft.addEventListener('mouseout', () => {
				blockLeft
					.closest('.frontpage-product-duo')
					.classList.remove('left-active');
			});

			blockRight.addEventListener('mouseover', () => {
				blockRight
					.closest('.frontpage-product-duo')
					.classList.add('right-active');
			});

			blockRight.addEventListener('mouseout', () => {
				blockRight
					.closest('.frontpage-product-duo')
					.classList.remove('right-active');
			});
		}
	};

	hoverEffect();
	window.addEventListener('resize', hoverEffect);
};

const initProduct = () => {
	//subscription options & frequency dropdown
	const purchaseTypes = document.querySelectorAll('.purchase-type');
	const purchaseTypesSub = document.querySelector(
		'.purchase-type.subscription input[type="radio"]'
	);
	const purchaseFrequency = document.querySelector('.purchase-frequency');
	const purchaseQuantity = document.querySelector('.product-quantity input[name="quantity"]');

	on(
		'body',
		'click',
		'.purchase-type input[type="radio"], .purchase-type input[type="radio"] *',
		(e) => {
			let target = e.target.closest('.purchase-type');
			const form = e.target.closest('form[action="/cart/add"]');
			purchaseTypes.forEach((purchaseType) => {
				purchaseType.classList.remove('active');
			});
			purchaseFrequency.classList.remove('active');
			if (target.classList.contains('subscription')) {
				target.classList.add('active');
				purchaseFrequency.classList.add('active');
				form.dataset.activeType = 'subscription';
				if (purchaseQuantity) purchaseQuantity.value = 1
			} else {
				target.classList.add('active');
				form.dataset.activeType = 'one-time-purchase';
			}
		}
	);

	const dropdownTrigger = document.querySelector('.select-trigger');
	const dropdown = document.querySelector('.select');
	const dropdownOptions = document.querySelectorAll(
		'.custom-options .custom-option'
	);
	const propertiesSubscription = document.querySelector(
		'input[name="properties[subscription]"]'
	);

	dropdownOptions.forEach((option) => {
		const updateDropdownVal = (selectedOption) => {
			dropdownTrigger.dataset.value = selectedOption.dataset.value;
			dropdownTrigger.dataset.valueId = selectedOption.dataset.valueId;
			propertiesSubscription.value = selectedOption.dataset.valueId;
			propertiesSubscription.dataset.plan = selectedOption.dataset.value;
			dropdownTrigger.firstChild.data = selectedOption.innerHTML;
		};
		//onload value
		if (option.classList.contains('selected')) {
			updateDropdownVal(option);
			//update subscription id radio button
			purchaseTypesSub.value = option.getAttribute('data-value-id');
		}

		//onclick
		option.addEventListener('click', (e) => {
			if (e.target.classList.contains('selected')) {
				dropdown.classList.remove('active');
			} else {
				dropdownOptions.forEach((item) => {
					item.classList.remove('selected');
				});
				e.target.classList.add('selected');
				updateDropdownVal(e.target);
				//update subscription id radio button
				purchaseTypesSub.value = e.target.dataset.valueId;
				dropdown.classList.remove('active');
			}
		});
	});

	//toggle dropdown
	if (dropdownTrigger) {
		dropdownTrigger.addEventListener('click', () => {
			dropdown.classList.toggle('active');
		});

		document.addEventListener('click', (e) => {
			if (
				dropdown.classList.contains('active') &&
				e.target &&
				!e.target.classList.contains('select-trigger') &&
				!e.target.closest('.select-trigger') &&
				!e.target.classList.contains('custom-options') &&
				!e.target.closest('.custom-options')
			) {
				dropdown.classList.remove('active');
			}
		});
	}
};

// initiate site
window.addEventListener('DOMContentLoaded', () => {
	// execute pieces and components functions
	initItemQuantity();
	initFields();
	initAccordion();
	initFlickitySlider();
	initCart();
	// initCursor();
	initMarquee();

	// execute global and component functions
	initHeader();
	initPageTransition();
	initPageAnimation();
	initMessage();

	// execute page specific functions
	switch (root.id) {
		case 'template-frontpage':
			initFrontpage();
			break;

		case 'template-product-single':
			initProduct();
			break;

		case 'template-account':
			initAccount();
			break;
	}

	// make visible .avoid-style-flash elements
	setTimeout(() => {
		document.querySelectorAll('.avoid-style-flash').forEach((el) => {
			el.style.visibility = 'visible';
		});
	}, 400);

	setTimeout(() => {
		const wrap = document.querySelector('.frontpage-hero_object-wrap');
		if (!wrap) return;
		wrap.classList.remove("animation-delay");
	}, 3000);
});
